import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M7.99992 8.95297C9.14867 8.95297 10.0799 8.02172 10.0799 6.87297C10.0799 5.72422 9.14867 4.79297 7.99992 4.79297C6.85117 4.79297 5.91992 5.72422 5.91992 6.87297C5.91992 8.02172 6.85117 8.95297 7.99992 8.95297Z",
      stroke: "currentColor",
      "stroke-width": "1.2"
    }, null, -1),
    _createElementVNode("path", {
      d: "M2.41337 5.66065C3.72671 -0.112681 12.2801 -0.106014 13.5867 5.66732C14.4018 9.44221 10.8015 12.6471 8.9883 13.991C8.3949 14.4308 7.60432 14.4308 7.01096 13.991C5.19781 12.6468 1.59765 9.44061 2.41337 5.66065Z",
      stroke: "currentColor",
      "stroke-width": "1.2"
    }, null, -1)
  ]))]))
}
export default { render: render }